export default {
    layout: {
        loading: 'Trading in Progress',
        trading: 'Trading in Progress'
    },
    footer: {
       
    },
    menu: {
        home: 'Home',
        staking: 'Matrix',
        port: 'PORT',
        internet: 'Network',
        me: 'Me',
    },
    header: {
      
        selectLang: 'Select Language',
        close: 'Close',
        trading: 'Trading',
        dashboard: 'Dashboard',
        subscribeMatrix: 'Subscription Plans',
        portTaskCenter: 'PORT Task Center',
        network: 'Network',
        apiBinding: 'API Binding',
        gridTree: 'Grid Tree',
        account: 'Account',
        documents: 'Docs & Whitepaper',
        personalCenter: 'Profile',
        language: 'Language'
    },
    home: {
        recently1:'Community',
        staticrewares: 'Static',
        recentlyName: 'Ledger',
        recentlyInfo: 'Earnings History',
        dataUpdate: 'Last Updated',
        realtime: 'Live·BSC',
        totalRevenue: 'Total Earnings (USDT)',
        today: 'Today',
        totalTradingVolume: 'Total Volume',
        todayEarn: 'Earned Today',
        share: 'Share with Friends',
        shareDesc: 'Show your gains · Invite & earn',
        directReferrals: 'Direct Referrals',
        teamMembers: 'Team Members',
        thisWeek: 'This Week',
        copy: 'Copy',
        recently: 'Recent Earnings',
        netIncome: 'Net Earnings',
        dailyAverage: 'Daily Avg',
        quantitativeIncome: 'Quant',
        recommend: 'Referral',
        port: 'PORT',
        bonus: 'Bonus',
        all: 'All',
        todayTitle: 'Today',
        loadingMore: 'Load Earlier',
    
        recommendBonus: 'Referral Reward',
        portTaskPassed: 'PORT Task Passed',
        myProfit: 'My P&L',
        earningOnBitDeep: 'I\'m earning on BitDeep',
        totalRevenueUsdt: 'Total Earnings · USDT',
        consecutiveDays: 'Day Streak',
        scanToJoin: 'Scan to Join',
        uid: 'UID',
        referralBonus: 'Referral Reward',
        shareTo: 'Share to',
        eachReferral: 'Share Reward',
        screenshotAndShare: 'Screenshot & Share',
        saveShareEarn: 'Save · Share · Earn',
        period: 'Period',
        netProfit: 'Net Earnings',
        quantReward: 'Quant Earnings',
        dailyBonus: 'PORT Daily Reward',
        close: 'Close',
        permission: 'Permissions',
        onlyEnable: 'Only enable',
        enterBitgetUid: 'Enter Bitget UID',
        slogan: 'Passphrase',
        document: 'Docs',
       
        days: 'Days',
        taskText: 'Task',
       
      
        minutes: 'Min',
    
        decentralizedPortTech: 'Technical architecture of decentralized PoRT, BGB tokenomics, and the dual-zone incentive matrix.',
        auditReport: 'Audit Report',
        faqSupport: 'FAQ & Support',
        telegram: 'Telegram',
        piece: 'share(s)',
        faq: 'FAQ',
        faq1: 'How do I bind the Bitget API?',
        faq1Desc: 'Go to Bitget Exchange → Settings → API Management to obtain your API Key and Secret. Enable Spot Trading permissions only; never enable withdrawal permissions. Paste the keys into the BitDeep DApp — once you complete a 1 USDT test trade the binding is activated.',
        faq2: 'What is PoRT (Proof of Real Trading)?',
        faq2Desc: 'PoRT is the core mechanism of "trading-as-mining". Each day the system uses your Bitget API to automatically execute fast buy-sell trades on a designated coin (e.g. BGB). When trading volume exceeds Stake × 50%, the system verifies it and triggers the daily reward.',
        faq3: 'Do I need to manually watch the market every day?',
        faq3Desc: 'No. Once the API is bound, the system automatically completes the trading task within a 24-hour window — no manual action is required. You can check progress in the PoRT menu.',
        faq4: 'What\'s the difference between ALPHA and SIGMA?',
        faq4Desc: 'ALPHA (Starter): 500 USDT stake, 0.3–1.3% daily yield, limited to 1 plan. SIGMA (Pro): 1,000 USDT stake, 0.6–1.6% daily yield, up to 5 plans.',
        faq5: 'Is my money safe? Can the platform touch my funds?',
        faq5Desc: 'Your funds remain 100% in your own Bitget account. The API only grants read & spot-trading permissions; the system cannot withdraw or transfer any principal.',
        faq6: 'When are daily earnings settled?',
        faq6Desc: 'After PoRT verification passes, settlement happens the next day. The system automatically releases a dual reward: USDT earnings plus 10x Deep points.',
        faq7: 'How is the Scout Bonus (Direct Referral Reward) calculated?',
        faq7Desc: 'For each active account you directly refer, you earn a fixed daily reward: 1 USDT/day for an ALPHA (500 USDT) referral and 2 USDT/day for a SIGMA (1,000 USDT) referral, paid until that account\'s cycle ends.',
        faq8: 'How do I level up (D1–D7)?',
        faq8Desc: 'You level up by meeting your minor-zone (weaker leg) total-volume threshold. For example: D1 requires 2,000 USDT, D3 requires 15,000 USDT, and the top tier D7 requires 3,000,000 USDT in volume. The higher the level, the richer the level-differential bonus (up to 7 USDT/person/day at D7).',
        faq9: 'How many days is one cycle? What happens at the end?',
        faq9Desc: 'One cycle is 28 days. When the cycle ends you can choose to continue staking; rewards are then paid out variably based on actual daily PoRT verification results.',
        faq10: 'Are there fees for withdrawals?',
        faq10Desc:'Withdrawals carry zero fees. The platform redirects any withdrawal fees back into the pool to thicken LP liquidity, creating a virtuous cycle.',
        bigArea: 'Major Zone',
        smallArea: 'Minor Zone',

        enterWithdrawAmount: 'Enter withdrawal amount',
        all: 'All',
        available: 'Available',

        totalAmount: 'Total Amount',
        confirmWithdraw: 'Confirm Withdrawal',
        withdrawRecord: 'Withdrawal History',

        withdrawn: 'Withdrawn',
        quickStartGuide:'Quick Start',
        whitepaperGuide:'Whitepaper & Guide',
        whitepaper:'Whitepaper',
        downloadPdf:'Download'
    },
    staking: {
        subscribeMatrix: '',
        selectPackage: 'Subscription Plans',
        stakingDesc: '',
        alpha: 'ALPHA',
        beginner: 'Starter',
        sigma: 'SIGMA',
        professional: 'Pro',
        popular: 'Most Popular',
        dailyReturn: 'Task Rewards',
        teamDepth: 'Team Depth',
        limitPurchase: 'Limit',
        layer: 'Layers',
        copy: 'share(s)',
        autoRenew: 'Auto-renew on expiry',
        autoReinvest: 'Automatic Renewal Margin',
        subscribeAlpha: 'Subscribe Alpha',
        subscribeSigma: 'Subscribe Sigma',
        stakedAmount: 'Margin',
        stakedAmount2: 'cycle',
        stakedAmount3: 'Cumulative Earnings',
        stakingTime: 'Participation Time',
        maturityTime: 'Expiry Date',
        redeem: 'Redeem',
        renew: 'Renew',
        autoRenewActive: 'Auto-renewal On',
        autoRenewInactive: 'Auto-renewal Off',
        smartContract: 'Smart-contract custody. Margin are locked for the 28-day cycle and unlocked at expiry.',
        alter2:'The pledge has expired, please renew it.',
    },
    me: {
        account: 'Account',
        my: 'Me',
        staked: 'Participated',
        staked1:'Margin',
        points: 'Points',
        consecutive: 'Day Streak',
        withdraw: 'Withdraw',
        language: 'Language',
        simplifiedChinese: 'Simplified Chinese',
        disconnectWallet: 'Disconnect Wallet',
        level: 'Level',
        joinDate: 'Joined',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'API Bind',
        bindDesc: 'Bind your exchange API key to authorize quant trading',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'Exchange',
     
        futures: 'Futures',
        spot: 'Spot',
        readOnly: 'Read-only',
        bind: 'Bind',

        riskNote: 'API key is used only for trade-data sync. No sensitive data is stored.',
        apiConnection: 'API Connection',
        bindExchangeApi: 'Bind Exchange API',
        bitDeepRead: 'BitDeep reads your CEX account\'s order flow to verify Proof of Real Trading (PoRT).',
        noWithdraw: 'We never touch your withdrawals.',
        securityTip: 'Security Notice · Please Read Carefully',
        close: 'Close',
        withdraw: 'Withdraw',
        permission: 'Permissions',
        onlyEnable: 'Only enable',
        spotTrading: 'Spot Trading',
        read: 'Read',
        recommendedPartner: 'Recommended Partner',
        zeroFee: '0% Fee',
        activated: 'Active',
        classicAccount: 'Classic Account',
        unifiedAccount: 'Unified Account',
        bindBitgetApi: 'Bind Bitget API',
        upcoming: 'Coming Soon',
        underAudit: 'Integration in Audit',
        expected: 'ETA'
    },
    port: {
        portTaskCenter: 'PoRT Task Center',
        dailyTask: 'Daily Tasks',
        verify: 'Verify',
        completed: 'Completed',
        incomplete: 'Incomplete',
        verifyStandard: 'Verification Criteria',
        tradingVolume: 'Volume',
        today: 'Today',
        deadline: 'Deadline',
        reward: 'Reward',
        startVerify: 'Start Verification',
        verifying: 'Verifying',
        verified: 'Verified',
        insufficient: 'Below Threshold',
        viewDetails: 'View Details',
        taskList: 'Task List',
        allTasks: 'All Tasks',
        completedTasks: 'Completed',
        pendingTasks: 'Pending',
        proofOfRealTrading: 'Proof of Real Trading',
        todayTask: 'Today\'s Task',
        todayStaticIncome: 'Today\’s Task Rewards',
        points: 'Points',
        todayWindowClosesAt: 'Today\'s window closes in',
        checkTaskStatus: 'Check Task Status',
        teamProgress: 'Team Progress · Today',
        realtimePortCompletion: 'Live PORT Completions',
        completedText: 'Completed',
        pendingText: 'Pending',
        realtimeApiValidationFlow: 'Live · API · Verification Stream',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'Network',
        treeBrowser: 'Tree Explorer',
        searchAddress: 'Search 0x… address or BD-ID',
        totalTradingVolume: 'Total Volume',
        members: 'members',
        networkStructure: 'Network Structure',
        allLevels: 'All Levels',
        addRemark: 'Add Note',
        enterRemark: 'Enter a note',
        cancel: 'Cancel',
        confirm: 'Confirm',
        alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
    },
    whitePaper: {
    },
    withdraw: {
        withdraw: 'Withdraw',
        usdtAsset: 'USDT Assets',
        withdrawAmount: 'Withdrawal Amount',
        availableBalance: 'Available Balance',
        fee: 'Fee',
        actualArrival: 'Net Received',
        submit: 'Submit',
        withdrawSuccess: 'Successful',
        withdrawFailed: 'Failed',
        processing: 'Processing',
        completed: 'Task Incomplete',
        withdrawHistory: 'Withdrawal History'
    },
    popup: {
        taskUnfinished: 'Task Incomplete',
        taskUnfinishedDesc: 'Trading data didn\'t meet today\'s PoRT verification threshold.',
        todayTradingVolume: 'Today Trading Amount',
        remaining: 'Need',
        toComplete: 'to complete today\'s task',
        tradingVolumeThreshold: '',
        deadline: 'Time left until deadline',
        tryAgain: 'Try Later',
        goTrade: 'Go Trade',
        taskCompleted: 'Task Verified',
        taskCompletedDesc: 'Today\'s PoRT proof has been recorded on-chain.',
        rewardIssued: 'Reward Issued',
        complete: 'Done',
        shareTitle: 'Share Invite',
        shareDesc: 'Invite friends to sign up — both of you earn rewards.',
        referralLink: 'Invite Link',
        qrCode: 'QR Code',
        copyLink: 'Copy Link',
        notask:'No Task Today',
        notaskDesc:'There are no pending PoRT trading tasks right now',
    }
};
